var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['message-abstract-image-container']},[_c('img',{class:['message-abstract-image'],attrs:{"src":_setup.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }